/* Optimum Fusion cart helpers: Bundle & Save 15% offer on the cart page, a note on bundle product pages, and the Added-to-cart screen. The 15% itself comes from ONE automatic discount in Shopify (15% OFF on Collagen, L-Glutamine and High Chief). */
(function () {
  var OFFER = ['opti-flexiglow', 'opti-guard', 'high-chief'];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nf = window.fetch.bind(window), cache = {}, busy = false, cool = 0;
  function money(c) { return 'AED ' + (c / 100).toFixed(2); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function onCart() { return location.pathname.replace(/\/$/, '') === (root + 'cart').replace(/\/$/, ''); }
  function gj(u) { return nf(u, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw 0; return r.json(); }); }
  function gp(h) { if (!cache[h]) cache[h] = gj(root + 'products/' + h + '.js').catch(function () { return null; }); return cache[h]; }
  function add(id, q) {
    return nf(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: q || 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); });
  }
  function hideDrawer() {
    document.querySelectorAll('cart-drawer').forEach(function (d) {
      if (d.open || d.hasAttribute('open')) { if (typeof d.hide === 'function') d.hide(); else if (typeof d.close === 'function') d.close(); }
    });
  }
  /* offer every bundle product that is not already in the cart, whatever the quantities are */
  function pick(cart) {
    if (!cart.items || !cart.items.length) return Promise.resolve(null);
    var inC = {}; cart.items.forEach(function (i) { inC[i.handle] = 1; });
    var l = OFFER.filter(function (h) { return !inC[h]; });
    if (!l.length) return Promise.resolve(null);
    return Promise.all(l.map(gp)).then(function (ps) { ps = ps.filter(function (p) { return p && p.available; }); return ps.length ? ps : null; });
  }
  function hintFor(cart) { return ''; }

  function styles() {
    if (document.getElementById('of-upsell-css')) return;
    var st = document.createElement('style'); st.id = 'of-upsell-css';
    st.textContent =
      '.of-upsell{margin:0 0 12px;padding:12px;border:1px solid rgba(62,166,183,.6);border-radius:12px;background:#f2fafb;color:#042e3a;text-align:left;display:grid;gap:10px}' +
      '.of-upsell__tag{display:inline-block;background:#3ea6b7;color:#fff;font-weight:700;font-size:11px;letter-spacing:.5px;text-transform:uppercase;padding:3px 9px;border-radius:999px}' +
      '.of-upsell__head{display:flex;flex-wrap:wrap;align-items:center;gap:8px;font-weight:700;font-size:14px}' +
      '.of-upsell__hint{margin:0;font-size:13px;font-weight:700;color:#042e3a}' +
      '.of-upsell__row{display:flex;align-items:center;gap:10px}' +
      '.of-upsell__img{width:56px;height:56px;background:#fff;border-radius:8px;border:1px solid rgba(62,166,183,.3);display:flex;align-items:center;justify-content:center;overflow:hidden;flex-shrink:0}' +
      '.of-upsell__img img{width:100%;height:100%;object-fit:contain}' +
      '.of-upsell__info{display:flex;flex-direction:column;gap:2px;min-width:0;flex:1}' +
      '.of-upsell__title{font-size:13px;font-weight:600;line-height:1.3}.of-upsell__price{font-size:13px}.of-upsell__price s{opacity:.55;margin-right:6px}' +
      '.of-upsell__select{width:100%;padding:8px 10px;border-radius:8px;border:1px solid rgba(62,166,183,.5);background:#fff;color:#042e3a;font-size:13px}' +
      '.of-upsell__qty{display:flex;align-items:center;justify-content:space-between;gap:10px;font-size:13px;font-weight:600}' +
      '.of-upsell__step{display:flex;align-items:center;border:1px solid rgba(62,166,183,.5);border-radius:999px;overflow:hidden;background:#fff}' +
      '.of-upsell__step button{width:38px;height:36px;border:0;background:transparent;color:#042e3a;font-size:20px;line-height:1;cursor:pointer}' +
      '.of-upsell__step input{width:40px;height:36px;border:0;text-align:center;font-size:15px;font-weight:700;color:#042e3a;background:#fff;-moz-appearance:textfield}' +
      '.of-upsell__one{display:grid;gap:10px}.of-upsell__tabs{display:grid;grid-auto-flow:column;grid-auto-columns:minmax(0,1fr);gap:6px}' +
      '.of-upsell__tab{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:6px 4px;line-height:1.15;border:2px solid rgba(62,166,183,.35);border-radius:10px;background:#fff;color:#042e3a;font-weight:700;font-size:12px;cursor:pointer;text-align:center}' +
      '.of-upsell__tab img{width:34px;height:34px;object-fit:contain;flex-shrink:0}.of-upsell__tab.is-on{border-color:#3ea6b7;background:#e6f5f7;box-shadow:0 0 0 1px #3ea6b7}' +
      '.of-upsell__note{margin:0;font-size:12px;color:#3ea6b7;font-weight:600}.of-upsell__done{margin:0;font-size:14px;font-weight:700;color:#3ea6b7}' +
      '.of-btn{display:block!important;width:100%!important;padding:14px!important;border:0!important;border-radius:999px!important;background:#3ea6b7!important;color:#fff!important;font-weight:700!important;font-size:16px!important;line-height:1.2!important;cursor:pointer;opacity:1!important;visibility:visible!important;text-align:center!important;text-decoration:none!important}' +
      '.of-btn[disabled]{opacity:.6!important;cursor:default}.of-btn--ghost{background:transparent!important;color:#3ea6b7!important;border:2px solid #3ea6b7!important}' +
      '.of-added{position:fixed;inset:0;z-index:2147483000;background:rgba(4,46,58,.7);display:flex;align-items:center;justify-content:center;padding:20px}' +
      '.of-added__box{width:100%;max-width:400px;background:#fff;color:#042e3a;border-radius:18px;padding:26px 20px 20px;display:grid;gap:12px;justify-items:stretch;text-align:center;box-shadow:0 12px 44px rgba(0,0,0,.35)}' +
      '.of-added__check{width:56px;height:56px;border-radius:50%;background:#3ea6b7;color:#fff;display:flex;align-items:center;justify-content:center;font-size:30px;margin:0 auto 2px}' +
      '.of-added__title{margin:0;font-size:18px;font-weight:800;line-height:1.3}.of-added__sub{margin:0 0 6px;font-size:14px;opacity:.75;line-height:1.35}' +
      '.of-simple-cart .additional-checkout-buttons,.of-simple-cart shopify-accelerated-checkout-cart,.of-simple-cart [data-shopify="dynamic-checkout-cart"]{display:none!important}' +
      '.of-note{margin:12px 0 0;padding:10px 12px;border:1px solid rgba(62,166,183,.6);border-radius:10px;background:rgba(62,166,183,.14);font-size:13px;line-height:1.4}';
    document.head.appendChild(st);
  }

  function build(list, where, hint) {
    if (!Array.isArray(list)) list = [list];
    var wrap = document.createElement('div'); wrap.className = 'of-upsell';
    wrap.setAttribute('data-of-upsell', list.map(function (x) { return x.handle; }).join(','));
    var head = '<div class="of-upsell__head"><span class="of-upsell__tag">Bundle &amp; Save 15%</span><span>' + (list.length > 1 ? 'Choose what you like' : 'Complete your stack') + '</span></div>' + (hint ? '<p class="of-upsell__hint">' + esc(hint) + '</p>' : '');
    var tabs = '';
    if (list.length > 1) {
      tabs = '<div class="of-upsell__tabs">' + list.map(function (x, i) {
        var im = x.featured_image ? (x.featured_image.indexOf('//') === 0 ? 'https:' + x.featured_image : x.featured_image) : '';
        var sh = x.handle === 'opti-flexiglow' ? 'Collagen' : (x.handle === 'opti-guard' ? 'L-Glutamine' : (x.handle === 'high-chief' ? 'High Chief' : x.title));
        return '<button type="button" class="of-upsell__tab' + (i === 0 ? ' is-on' : '') + '" data-i="' + i + '">' + (im ? '<img src="' + esc(im + (im.indexOf('?') > -1 ? '&' : '?') + 'width=80') + '" alt="">' : '') + '<span>' + esc(sh) + '</span></button>';
      }).join('') + '</div>';
    }
    wrap.innerHTML = head + tabs + '<div data-of-body></div>';
    var body = wrap.querySelector('[data-of-body]');
    function show(i) {
      body.innerHTML = ''; body.appendChild(one(list[i], where, wrap));
      wrap.querySelectorAll('.of-upsell__tab').forEach(function (t) { t.classList.toggle('is-on', Number(t.getAttribute('data-i')) === i); });
    }
    wrap.querySelectorAll('.of-upsell__tab').forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); show(Number(t.getAttribute('data-i'))); }); });
    show(0);
    return wrap;
  }

  function one(p, where, wrap) {
    var av = p.variants.filter(function (v) { return v.available; });
    var first = av[0] || p.variants[0];
    var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
    var opts = p.variants.length > 1 ? '<select class="of-upsell__select" aria-label="Choose option">' + av.map(function (v) { return '<option value="' + v.id + '" data-p="' + v.price + '">' + esc(v.title) + '</option>'; }).join('') + '</select>' : '';
    var el = document.createElement('div'); el.className = 'of-upsell__one';
    el.innerHTML =
      '<div class="of-upsell__row"><div class="of-upsell__img">' + (img ? '<img src="' + esc(img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120') + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
      '<div class="of-upsell__info"><span class="of-upsell__title">' + esc(p.title) + '</span><span class="of-upsell__price"></span></div></div>' + opts +
      '<div class="of-upsell__qty"><span>Quantity</span><div class="of-upsell__step"><button type="button" data-d="-1" aria-label="Less">&minus;</button><input type="number" min="1" max="20" value="1" inputmode="numeric"><button type="button" data-d="1" aria-label="More">+</button></div></div>' +
      '<p class="of-upsell__note">15% off every one you add here</p>' +
      '<button type="button" class="of-btn of-upsell__btn">Add &amp; Save 15%</button>';
    var btn = el.querySelector('.of-upsell__btn'), sel = el.querySelector('.of-upsell__select'), qi = el.querySelector('.of-upsell__step input'), pr = el.querySelector('.of-upsell__price');
    function qty() { var q = parseInt(qi.value, 10); return q > 0 ? Math.min(q, 20) : 1; }
    function unit() { return sel ? Number(sel.options[sel.selectedIndex].getAttribute('data-p')) : first.price; }
    function price() { var q = qty(), u = unit(); pr.innerHTML = '<s>' + money(u * q) + '</s><strong>' + money(Math.round(u * 0.85) * q) + '</strong>'; }
    el.querySelectorAll('.of-upsell__step button').forEach(function (b) { b.addEventListener('click', function () { qi.value = Math.max(1, Math.min(20, qty() + Number(b.getAttribute('data-d')))); price(); }); });
    qi.addEventListener('input', price); if (sel) sel.addEventListener('change', price); price();
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = sel ? sel.value : first.id, q = qty();
      btn.disabled = true; btn.textContent = 'Adding...';
      add(id, q).then(function () { location.reload(); })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add & Save 15%'; alert('Sorry, this product is not available right now.'); });
    });
    return el;
  }

  /* after Add to cart: a clear screen with Go to Cart and Continue Shopping. The Bundle offer lives on the cart page. */
  function closeAdded(m) { if (m && m.parentNode) m.parentNode.removeChild(m); document.documentElement.style.overflow = ''; }
  function showAdded(title) {
    if (document.querySelector('.of-added')) return;
    styles(); hideDrawer(); setTimeout(hideDrawer, 400); setTimeout(hideDrawer, 900);
    var m = document.createElement('div'); m.className = 'of-added';
    m.innerHTML = '<div class="of-added__box" role="dialog" aria-modal="true" aria-label="Added to cart"><div class="of-added__check">&#10003;</div><p class="of-added__title">Added to your cart</p><p class="of-added__sub">' + (title ? esc(title) : '') + '</p><a class="of-btn" href="' + root + 'cart">Go to Cart</a><button type="button" class="of-btn of-btn--ghost" data-of-close>Continue Shopping</button></div>';
    m.querySelector('[data-of-close]').addEventListener('click', function () { closeAdded(m); });
    m.addEventListener('click', function (e) { if (e.target === m) closeAdded(m); });
    document.body.appendChild(m); document.documentElement.style.overflow = 'hidden';
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
    var p = nf(input, init);
    if (method === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(url) && !onCart()) {
      p.then(function (res) {
        if (!res.ok) return;
        res.clone().json().then(function (d) {
          if (d && d.status && d.status >= 400) return;
          var it = d && (d.items ? d.items[0] : d);
          showAdded(it && (it.product_title || it.title));
        }).catch(function () { showAdded(''); });
      }).catch(function () {});
    }
    return p;
  };

  function hideExtras() {
    document.querySelectorAll('[id^="CartDiscount-"], form[is="cart-discount"]').forEach(function (f) { var b = f.closest('details') || f.closest('.accordion') || f; if (b.style.display !== 'none') b.style.display = 'none'; });
    document.querySelectorAll('main-cart p, main-cart div, cart-drawer p, cart-drawer div, #MainContent p').forEach(function (n) {
      if (n.children.length === 0 && /^\s*International shipments via DHL/i.test(n.textContent) && n.style.display !== 'none') n.style.display = 'none';
    });
  }

  function simplePage() {
    if (!onCart()) return;
    styles(); document.documentElement.classList.add('of-simple-cart');
    document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (b.closest('cart-drawer')) return;
      var h = b.parentElement;
      if (!h || !h.parentElement || h.parentElement.querySelector('[data-of-continue]')) return;
      var c = document.createElement('a'); c.href = root + 'collections/all'; c.className = 'of-btn of-btn--ghost'; c.style.marginTop = '12px';
      c.setAttribute('data-of-continue', ''); c.textContent = 'Continue Shopping';
      h.parentElement.insertBefore(c, h.nextSibling);
    });
  }

  /* note on the Collagen / L-Glutamine / High Chief product pages */
  function pageNote() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m || OFFER.indexOf(m[1]) < 0 || document.querySelector('[data-of-note]')) return;
    var bb = document.querySelector('form.product-form .buy-buttons'); if (!bb) return;
    var host = bb.closest('form') || bb; styles();
    var n = document.createElement('p'); n.className = 'of-note'; n.setAttribute('data-of-note', '');
    n.innerHTML = '<b>15% OFF</b> &ndash; applied automatically on every piece, no code needed.';
    host.parentNode.insertBefore(n, host.nextSibling);
  }

  function run() {
    hideExtras(); simplePage(); pageNote();
    if (busy || Date.now() < cool) return;
    var spots = [];
    if (onCart()) document.querySelectorAll('[name="checkout"]').forEach(function (b) {
      if (b.closest('cart-drawer')) return;
      var h = b.parentElement;
      if (h && h.parentElement && !h.parentElement.querySelector('[data-of-upsell]')) spots.push({ p: h.parentElement, b: h, w: 'page' });
    });
    if (!spots.length) return;
    busy = true;
    gj(root + 'cart.js').then(function (c) { return pick(c).then(function (p) { return { c: c, p: p }; }); }).then(function (r) {
      if (!r.p) { cool = Date.now() + 4000; return; }
      styles();
      spots.forEach(function (sp) {
        if (sp.p.querySelector('[data-of-upsell]')) return;
        sp.p.insertBefore(build(r.p, sp.w, hintFor(r.c)), sp.b);
      });
    }).catch(function () {}).then(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.cart-drawer-button, header a[href$="/cart"], .header a[href$="/cart"], [aria-controls^="CartDrawer"]');
    if (!a || a.closest('cart-drawer')) return;
    e.preventDefault(); e.stopImmediatePropagation(); location.href = root + 'cart';
  }, true);

  setTimeout(function () { OFFER.forEach(gp); }, 1200);
  var t;
  function schedule() { clearTimeout(t); t = setTimeout(run, 350); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule); else schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
